import { createPayload } from './common'

export default (name) => {
  const initialState = createPayload(null)

  return (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
      case `${name}_INITIAL`:
      case `${name}_SUCCESS`:
      case `${name}_ERROR`:
        return payload
      default:
        return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/utils/asyncReducer.js